import apiCall from '../../../commons/helpers/apiCall';
import { getBeaconToken } from '../../../commons/utils';

const BRAINTREE_TOKEN = [
  {
    clientToken: `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`,
  },
];

export async function fetchBraintreeClientTokenAPI() {
  const result = await apiCall({
    endpoint: `payment/client-token`,
    options: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Session-Id': getBeaconToken(),
      },
      redirect: 'follow',
    },
    authorize: false,
  });
  return result;
  // return BRAINTREE_TOKEN;
}

export async function fetchQuoteById(id) {
  const result = await apiCall({
    endpoint: `quote/${id}`,
    options: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
    },
    authorize: false,
  });
  return result;
}

export async function createQuote(data, version = 'V1') {
  const result = await apiCall({
    endpoint: 'quote',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
      redirect: 'follow',
    },
    version,
    authorize: false,
  });
  return result;
}

export async function updateQuote(data, version = 'V1') {
  const result = await apiCall({
    endpoint: 'quote',
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
      redirect: 'follow',
    },
    version: version,
    authorize: false,
  });
  return result;
}

export async function deleteQuoteItemById(quoteId, itemId) {
  const result = await apiCall({
    endpoint: `quote?quoteId=${quoteId}&itemId=${itemId}`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
    },
    authorize: false,
  });
  return result;
}

export async function fetchTax(data) {
  const result = await apiCall({
    endpoint: `quote/tax`,
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
      redirect: 'follow',
    },
    authorize: false,
  });
  return result;
}

export async function applyCoupon(data) {
  const result = await apiCall({
    endpoint: `quote/coupon`,
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
      redirect: 'follow',
    },
    authorize: false,
  });
  return result;
}

export async function deleteCoupon(quoteId) {
  const result = await apiCall({
    endpoint: `quote/coupon?quoteId=${quoteId}`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
    },
    authorize: false,
  });
  return result;
}

export async function createOrder(data) {
  const result = await apiCall({
    endpoint: 'order',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
      redirect: 'follow',
    },
    authorize: false,
  });
  return result;
}

export async function createNewOrder(data) {
  const result = await apiCall({
    endpoint: 'newOrder',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
      redirect: 'follow',
    },
    authorize: false,
  });
  return result;
}

export async function prepCart(data) {
  const result = await apiCall({
    endpoint: 'prepareCart',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
      redirect: 'follow',
    },
    authorize: false,
  });
  return result;
}

export async function fetchOrderDetails(orderId, authorize) {
  const result = await apiCall({
    endpoint: `order/${orderId}`,
    options: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
    },
    authorize,
  });
  return result;
}
